import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const IP = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`suspiciousActivityInfo.ipAddresses.${index as 0}.ip`}
      control={control}
      render={({ field }) => (
        <FF2 label="IP" field={field} input={(props) => <TextInput {...props} maxLength={50} />} />
      )}
    />
  )
}
